import { ApolloLink } from "apollo-link";
import { split, HttpLink, InMemoryCache, ApolloClient } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { createUploadLink } from 'apollo-upload-client';

import Cookies from "js-cookie";
import moment from "moment";

import { auth } from "~components/firebase/firebase";
import { store } from "../store";
import { LOGOUT } from "../store/actions";

const env = process.env.NODE_ENV;
const domain = env === "development" ? "localhost" : ".mudey.pt";
const url = process.env.REACT_APP_API_URL;
const wsURL =
  env === "development"
    ? "wss://staging-api.mudey.pt/subscriptions"
    : process.env.REACT_APP_WSS_URL;

const httpLink = createUploadLink({
  uri: url,
  credentials: "include",
});

const authLink = setContext((_, { headers }) => {
  if (auth.currentUser) {
    const expirationHardLimit = Cookies.get("MUDEY_hard_expiration");
    // ! clean up

    const expiresAt = auth.currentUser.stsTokenManager.expirationTime;
    const sessionExpired =
      moment().isAfter(moment(expiresAt)) ||
      moment().isAfter(moment(expirationHardLimit));
    const lessThenFourtyMinutes = moment().isAfter(
      moment(expiresAt).subtract(30, "minutes")
    );

    if (lessThenFourtyMinutes && !sessionExpired) {
      auth.currentUser
        .getIdToken(true)
        .then(function(idToken) {
          // ! clean up

          Cookies.set("Mudey_partner_token", idToken);
        })
        .catch(function(error) {
          console.log("error: ", error);
        });
    }

    if (sessionExpired) {
      // ! clean up

      store.dispatch({ type: LOGOUT });
    }
  }

  const token = Cookies.get("Mudey_partner_token") || "insta-checkout";

  return {
    headers: {
      ...headers,
      MUDEY_AUTH_TOKEN: token,
    },
  };
});

const wsLink = new WebSocketLink({
  uri: wsURL,
  options: {
    connectionParams: async () => {
      const app_token = await Cookies.get("Mudey_partner_token");

      return {
        credentials: "include",
        MUDEY_AUTH_TOKEN: app_token,
        Authorization: "Basic bXVkZXlkZXZhcGk6aXRzdGltZQ==",
      };
    },
  },
});

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  authLink.concat(httpLink)
);

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([link]),
});

export default client;